'use client'

import dynamic from 'next/dynamic'
import { Suspense } from 'react'
import { useCart } from '@/context/CartContext'

// Dynamic imports for client-side only components
const CartDrawer = dynamic(() => import('@/components/cart/CartDrawer'), {
  ssr: false,
  loading: () => null
})

const Toaster = dynamic(
  () => import('react-hot-toast').then((mod) => mod.Toaster),
  {
    ssr: false,
  }
)

export function ClientCartDrawer() {
  const { isOpen } = useCart()

  if (!isOpen) return null

  return <CartDrawer />
}

export function ClientToaster() {
  return (
    <Suspense fallback={null}>
      <Toaster
        position="top-right"
        containerStyle={{
          top: 20,
          right: 20,
          zIndex: 99999,
        }}
        toastOptions={{
          duration: 4000,
          style: {
            borderRadius: '8px',
            background: '#363636',
            color: '#fff',
            padding: '12px 16px',
            fontSize: '14px',
            zIndex: 99999,
          },
          success: {
            style: {
              background: '#10b981',
              color: '#fff',
            },
            iconTheme: {
              primary: '#fff',
              secondary: '#10b981',
            },
          },
          error: {
            style: {
              background: '#ef4444',
              color: '#fff',
            },
            iconTheme: {
              primary: '#fff',
              secondary: '#ef4444',
            },
          },
          loading: {
            style: {
              background: '#6366f1',
              color: '#fff',
            },
          },
        }}
      />
    </Suspense>
  )
}
